/*企业详情*/
import axios from "@/api/enterprise_system";

let method = 'GET';
/*id获取公司信息*/
export const getCompanyInfo = data => axios.post('/bqw/company/id', data)
/*根据cid获取工商信息(登记信息)*/
export const getBusinessInformationByCid = data => axios.post("/bqw/company/getBusinessInformationByCid", data)
/*股权穿透*/
export const getEquityPenetration = data => axios.post('/bqw/company/getEquityPenetration', data)
/*根据cid获取工商信息(股东信息)*/
export const getShareholderByCid = data => axios.post("/bqw/company/getShareholderByCid", data)
/*根据cid获取工商信息(主要人员)*/
export const getMainPersonnelByCid = data => axios.post("/bqw/company/getMainPersonnelByCid", data)
/*根据cid获取最终受益人*/
export const getCcBeneficiary = data => axios.post("/bqw/company/getCcBeneficiary", data)
/*根据cid获取对外投资*/
export const getInvestment = data => axios.post('/bqw/company/getInvestment', data)
/*根据cid获取疑似实际控制人*/
export const getActualController = data => axios.post("/bqw/company/getActualController", data)
/*控股公司*/
export const getNewDynamicList = data => axios.post("/bqw/company/getNewDynamicList", data)
/*根据cid获取(分支机构)*/
export const getBranch = data => axios.post("/bqw/company/getBranch", data)
/*根据cid获取工商信息(变更信息)*/
export const getChangeProjectByCid = data => axios.post("/bqw/company/getChangeProjectByCid", data)
/*根据cid获取企业年报*/
export const getAnnualReport = data => axios.post("/bqw/company/getAnnualReport", data)
/*公司id获取法律诉讼*/
export const getLegalProceedingsBycid = data => axios.post('/bqw/legalInformation/getLegalProceedingsBycid', data)
/*公司id获取开庭公告*/
export const getCourtNoticeBycid = data => axios.post('/bqw/legalInformation/getCourtNoticeBycid', data)
/*公司id获取获取法院公告*/
export const getDdCourtDeclaredBycid = data => axios.post('/bqw/legalInformation/getDdCourtDeclaredBycid', data)
/*送达公告*/
export const serviceNotice = data => axios.post('/bqw/legalInformation/serviceNotice', data)
/*公司id获取立案信息*/
export const getFilingInformationBycid = data => axios.post('/bqw/legalInformation/getFilingInformationBycid', data)
/*终本案件*/
export const getFinalCase = data => axios.post('/bqw/legalInformation/getFinalCase', data)
/*终本案件执行标的总金额/未履行总金额/比例*/
export const finalCaseTotalAmount = data => axios.post('/bqw/legalInformation/finalCaseTotalAmount', data)
/*公司id获取司法拍卖*/
export const getJudicialAuctionByCidList = data => axios.post('/bqw/legalInformation/getJudicialAuctionByCidList', data)
/*cid获取限制消费令*/
export const getAllConsumptionRestrictionOrder = data => axios.post('/bqw/legalInformation/getAllConsumptionRestrictionOrder', data)
/*失信信息*/
export const DishonestInformation = data => axios.post('/bqw/legalInformation/DishonestInformation', data)
/*公司id获取被执行人*/
export const getDdExecutedPersonBycid = data => axios.post('/bqw/legalInformation/getDdExecutedPersonBycid', data)
/*被执行人总金额*/
export const getDdExecutedPersonTotalAmount = data => axios.post('/bqw/legalInformation/getDdExecutedPersonTotalAmount', data)
/*司法协助*/
export const getJudicialAssistance = data => axios.post('/bqw/legalInformation/getJudicialAssistance', data)
/*询价评估--评选结果*/
export const inquirySelectionResults = data => axios.post('/bqw/legalInformation/inquirySelectionResults', data)
/*询价评估--评选机构*/
export const inquiryEvaluation = data => axios.post('/bqw/legalInformation/inquiryEvaluation', data)
/*cid获取司法解析*/
export const getJudicial = data => axios.post('/bqw/legalInformation/getJudicial', data)
/*详情*/
export const getDdCourtDeclaredDetails = data => axios.post('/bqw/courtDeclared/getDdCourtDeclaredDetails', data)
/*法院公告id获取法院公告详情*/
export const ddCourtDeclaredDetails = data => axios.post('/bqw/legalInformation/ddCourtDeclaredDetails/id', data)
/*开庭公告id获取开庭公告详情*/
export const courtNoticeDetails = data => axios.post('/bqw/legalInformation/courtNoticeDetails/id', data)
/*送达公告详情*/
export const serviceNoticeDetails = data => axios.post('/bqw/legalInformation/serviceNoticeDetails', data)
/*立案信息id获取立案信息详情*/
export const filingInformationDetails = data => axios.post('/bqw/legalInformation/filingInformationDetails/id', data)
/*终本案件详情*/
export const finalCaseDetails = data => axios.post('/bqw/legalInformation/finalCaseDetails', data)
/*司法拍卖id获取详情*/
export const getJudicialAuctionDetails = data => axios.post('/bqw/legalInformation/getJudicialAuctionDetails', data)
/*失信信息详情*/
export const getDishonestInformationDetails = data => axios.post('/bqw/dishonestInformation/getDishonestInformationDetails', data)
/*失信信息详情*/
export const DishonestInformationDetails = data => axios.post('/bqw/legalInformation/DishonestInformationDetails', data)
/*被执行人详情*/
export const getDdExecutedPersonByDetails = data => axios.post('/bqw/legalInformation/getDdExecutedPersonByDetails', data)
/*id获取司法协助详情*/
export const judicialAssistanceDetails = data => axios.post('/bqw/legalInformation/judicialAssistanceDetails', data)
/*通过公司名称获取es中的公司id*/
export const getCompanyId = data => axios.post('/bqw/company/getCompanyId', data)
/*司法解析详情*/
export const getJudicialDetails = data => axios.post('/bqw/legalInformation/getJudicialDetails', data)
/*经营异常*/
export const abnormalOperation = data => axios.post('/bqw/management/abnormalOperation', data)
/*公司id获取行政处罚*/
export const getDdAdministrativeSanctionBycid = data => axios.post('/bqw/management/getDdAdministrativeSanctionBycid', data)
/*id获取行政处罚详情*/
export const getDdAdministrativeSanctionDetailsById = data => axios.post('/bqw/management/getDdAdministrativeSanctionDetailsById', data)
/*公司id获取严重违法*/
export const seriousIllegal = data => axios.post('/bqw/management/seriousIllegal', data)
/*公司id获取股权出质*/
export const ddEquityContribution = data => axios.post('/bqw/management/ddEquityContribution/cid', data)
/*id获取股权出质详情*/
export const getDdEquityContributionDetailsById = data => axios.post('/bqw/management/getDdEquityContributionDetailsById', data)
/*公司id获取股权质押比例*/
export const getEquityPledgeRatioProportion = data => axios.post('/bqw/management/getEquityPledgeRatioProportion', data)
/*公司id获取重要股东质押统计（质押中）*/
export const getSignificantShareholdersByCid = data => axios.post('/bqw/management/getSignificantShareholdersByCid', data)
/*质押明细id获取股权质押（质押明细详情）*/
export const pledgeDetailsById = data => axios.post('/bqw/management/pledgeDetailsById', data)
/*公司id获取税收违法*/
export const taxViolation = data => axios.post('/bqw/management/taxViolation', data)
/*id获取税收违法详情*/
export const taxViolationDetails = data => axios.post('/bqw/management/taxViolationDetails', data)
/*id获取动产抵押详情*/
export const getChattelMortgageDetails = data => axios.post('/bqw/management/getChattelMortgageDetails', data)
/*公司id获取动产抵押列表*/
export const getChattelMortgageList = data => axios.post('/bqw/management/getChattelMortgageList', data)
/*公司id获取官方信息里获取环保处罚*/
export const getDdEnvironmentalPunishmentBycid = data => axios.post('/bqw/management/getDdEnvironmentalPunishmentBycid', data)
/*环保处罚id获取环保处罚详情*/
export const getDdEnvironmentalPunishmentDetailsByid = data => axios.post('/bqw/management/getDdEnvironmentalPunishmentDetailsByid', data)
/*id获取欠税公告详情*/
export const taxArrearsNoticeDetails = data => axios.post('/bqw/management/taxArrearsNoticeDetails', data)
/*公司id获取欠税公告*/
export const taxArrearsNotice = data => axios.post('/bqw/management/taxArrearsNotice', data)
/*cid获取公司清算信息*/
export const getClearInformation = data => axios.post('/bqw/management/getClearInformation', data)
/*知识产权出质列表*/
export const getNewPledgeIntellectualPropertyList = data => axios.post('/bqw/management/getNewPledgeIntellectualPropertyList', data)
/*知识产权出质详情*/
export const getNewPledgeIntellectualPropertyById = data => axios.post('/bqw/management/getNewPledgeIntellectualPropertyById', data)
/*公司id获取公告催示*/
export const noticeReminder = data => axios.post('/bqw/management/noticeReminder', data)
/*id获取公告催示详情*/
export const noticeReminderDetails = data => axios.post('/bqw/management/noticeReminderDetails', data)
/*公司id获取土地抵押*/
export const landMortgage = data => axios.post('/bqw/management/landMortgage', data)
/*id获取土地抵押详情*/
export const landMortgageDetails = data => axios.post('/bqw/management/landMortgageDetails', data)
/*简易注销*/
export const getNewSimpleCancellation = data => axios.post('/bqw/management/getNewSimpleCancellation', data)
/*获取重要股东质押统计（质押中）详情*/
export const getSignificantShareholdersDetails = data => axios.post('/bqw/management/getSignificantShareholdersDetails', data)
/*根据cid获取行政许可（信用中国）*/
export const administrativeLicensingChina = data => axios.post('/bqw/managementInFo/administrativeLicensingChina/cid', data)
/*根据行政许可（信用中国）id取行政许可（信用中国）详情*/
export const administrativeLicensingChinaDetails = data => axios.post('/bqw/managementInFo/administrativeLicensingChinaDetails/id', data)
/*根据cid获取招投标*/
export const getBiddingInfo = data => axios.post('/bqw/managementInFo/Bidding/cid', data)
/*招投标id获取招投标详情*/
export const BiddingDetails = data => axios.post('/bqw/managementInFo/BiddingDetails/id', data)
/*根据cid获取进出口信用*/
export const importExportCredit = data => axios.post('/bqw/managementInFo/importExportCredit/cid', data)
/*进出口信用id获取进出口信用详情*/
export const importExportCreditDetails = data => axios.post('/bqw/managementInFo/importExportCreditDetails/id', data)
/*根据cid获取资质证书*/
export const qualificationCertificate = data => axios.post('/bqw/managementInFo/qualificationCertificate/cid', data)
/*资质证书id获取证书详情*/
export const qualificationCertificateDetails = data => axios.post('/bqw/managementInFo/qualificationCertificateDetails/cid', data)
/*根据cid获取双随机抽查*/
export const doubleRandomSampling = data => axios.post('/bqw/managementInFo/doubleRandomSampling/cid', data)
/*根据id获取双随机抽查详情*/
export const doubleRandomSamplingDetails = data => axios.post('/bqw/managementInFo/doubleRandomSamplingDetails/id', data)
/*根据cid获取产品信息*/
export const productInformation = data => axios.post('/bqw/managementInFo/productInformation/cid', data)
/*根据cid获取供应商*/
export const getSupplier = data => axios.post('/bqw/managementInFo/supplier/cid', data)
/*根据cid获取税务评级*/
export const getTaxRating = data => axios.post('/bqw/managementInFo/taxRating/cid', data)
/*cid获取购地信息*/
export const landPurchaseInformation = data => axios.post('/bqw/managementInFo/landPurchaseInformation/cid', data)
/*购地信息id获取购地信息详情*/
export const landPurchaseInformationDetails = data => axios.post('/bqw/managementInFo/landPurchaseInformationDetails/id', data)
/*电信许可列表*/
export const getTelecomPermit = data => axios.post('/bqw/managementInFo/getTelecomPermit', data)
/*电信许可详情*/
export const getTelecomPermitDetails = data => axios.post('/bqw/managementInFo/getTelecomPermitDetails', data)
/*根据cid获取客户*/
export const getCustomer = data => axios.post('/bqw/managementInFo/customer/cid', data)
/*根据cid获取地块公示*/
export const landPublicity = data => axios.post('/bqw/managementInFo/landPublicity/cid', data)
/*根据id获取地块公示详情*/
export const landPublicityDetails = data => axios.post('/bqw/managementInFo/landPublicityDetails/id', data)
/*cid获取财务解析*/
export const financialAnalysis = data => axios.post('/bqw/managementInFo/financialAnalysis/cid', data)
/*根据cid获取土地转让*/
export const landTransfer = data => axios.post('/bqw/managementInFo/landTransfer/cid', data)
/*根据id获取土地转让详情*/
export const landTransferDetails = data => axios.post('/bqw/managementInFo/landTransferDetails/id', data)
/*根据cid获取公告研报（相关公告）*/
export const relevantNotice = data => axios.post('/bqw/managementInFo/relevantNotice/cid', data)
/*根据cid获取公告研报（企业研报）*/
export const researchReport = data => axios.post('/bqw/managementInFo/researchReport/cid', data)
/*根据cid获取抽查检查*/
export const DdSpotCheck = data => axios.post('/bqw/managementInFo/DdSpotCheck/cid', data)
/*根据cid获取融资历程*/
export const financingHistory = data => axios.post('/bqw/enterpriseDevelopment/financingHistory/cid', data)
/*根据cid获取核心团队*/
export const coreTeamPageList = data => axios.post('/bqw/enterpriseDevelopment/coreTeamPageList/cid', data)
/*根据cid获取企业业务*/
export const enterpriseBusinessPageList = data => axios.post('/bqw/enterpriseDevelopment/enterpriseBusinessPageList/cid', data)
/*企业业务基本信息*/
export const newGetEnterpriseBusinessEssentialInformation = data => axios.post('/bqw/enterpriseDevelopment/newGetEnterpriseBusinessEssentialInformation', data)
/*根据cid获取竞品信息*/
export const competitiveProductsInfo = data => axios.post('/bqw/enterpriseDevelopment/competitiveProductInformationPageList/cid', data)
/*投资机构列表*/
export const investmentAgencyList = data => axios.post('/bqw/enterpriseDevelopment/investmentInstitutionsPageList/cid', data)
/*私募基金列表*/
export const getPrivateOfferingFundList = data => axios.post('/bqw/enterpriseDevelopment/getPrivateOfferingFundList', data)
/*公司id获取知识产权类的专利信息*/
export const getPatentById = data => axios.post('/bqw/intellectualPropertyRight/patent/cid', data)
/*专利信息id获取专利信息详情*/
export const patentDetails = data => axios.post('/bqw/intellectualPropertyRight/patentDetails/cid', data)
/*公司id获取商标*/
export const getTrademarkById = data => axios.post('/bqw/intellectualPropertyRight/trademark/cid', data)
/*商标id获取商标详情*/
export const getTrademarkDetails = data => axios.post('/bqw/intellectualPropertyRight/trademarkDetails/id', data)
/*公司id获取作品著作权*/
export const copyrightWorks = data => axios.post('/bqw/intellectualPropertyRight/copyrightWorks/cid', data)
/*公司id获取网站备案*/
export const WebsiteFiling = data => axios.post('/bqw/intellectualPropertyRight/WebsiteFiling/cid', data)
/*网站备案详情*/
export const getWebsiteFilingDetails = data => axios.post('/bqw/intellectualPropertyRight/getWebsiteFilingDetails', data)
/*根据公司ID获取新闻列表*/
export const corporateNewsList = data => axios.post('/bqw/intellectualPropertyRight/corporateNewsList', data)
/*新闻详情*/
export const corporateNewsDetails = data => axios.post('/bqw/intellectualPropertyRight/corporateNewsDetails', data)
/*根据投资机构id获取--机构成员列表*/
export const INewAgencyMembersService = data => axios.post("/bqw/enterpriseDevelopment/INewAgencyMembersService", data)
/*获取基本信息*/
export const investmentInstitutionsDetails = data => axios.post('/bqw/enterpriseDevelopment/investmentInstitutionsDetails', data)
/*根据投资机构id获取--公开投资事件列表*/
export const getNewPublicInvestmentEventList = data => axios.post('/bqw/enterpriseDevelopment/getNewPublicInvestmentEventList', data)
/*根据投资机构id获取--基金管理人/ 管理基金*/
export const getNewFundManagementList = data => axios.post('/bqw/enterpriseDevelopment/getNewFundManagementList', data)
/*对外投资基金列表*/
export const getInvestmentFunds = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentFunds', data)
/*投资机构--新闻*/
export const getInvestmentAgencyNewsList = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentAgencyNewsList', data)
/*投资阶段*/
export const getInvestmentStage = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentStage', data)
/*投资阶段详情*/
export const getInvestmentStageDetails = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentStageDetails', data)
/*投资行业*/
export const getInvestmentIndustry = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentIndustry', data)
/*投资行业详情*/
export const getInvestmentIndustryDetails = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentIndustryDetails', data)
/*投资规模*/
export const getInvestmentScale = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentScale', data)
/*投资规模详情*/
export const getInvestmentScaleDetails = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentScaleDetails', data)
/*投资案例*/
export const getInvestmentCase = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentCase', data)
/*投资案例详情*/
export const getInvestmentCaseDetails = data => axios.post('/bqw/enterpriseDevelopment/getInvestmentCaseDetails', data)
/*法律诉讼id获取法律诉讼详情*/
export const getLegalProceedingsDetailsByid = data => axios.post('/bqw/legalInformation/getLegalProceedingsDetailsByid', data)
/*限制消费令详情*/
export const getConsumptionRestrictionOrderDetails = data => axios.post('/bqw/legalInformation/getConsumptionRestrictionOrderDetails', data)
/*根据id获取企业年报详情*/
export const annualReportRetails = data => axios.post("/bqw/company/annualReportRetails", data)
/*pc热门查询统计（专精特新小巨人、高新技术企业、企业技术中心、招投标、新增企业、众创空间）*/
export const pcPopularQueries=data=>axios.post('/bqw/newCompanyInfoController/pcPopularQueries',data)